import React from 'react';

function Button({ initialValue, color, type, iconLeft, onClick, iconRight, className,disabled }) {
    return (
        type === "fill" ?
            <button
            disabled={disabled}
                onClick={onClick}
                className={`${className} text-sm  h-12 px-3 py-2 hover:opacity-80 rounded-md justify-center items-center gap-2 inline-flex `}
            >
                {iconLeft && React.cloneElement(iconLeft, { fill: color })}
                {initialValue &&
                    <span className={`font-medium line-clamp-1`}>
                        {initialValue}
                    </span>
                }
                {iconRight && React.cloneElement(iconRight, { fill: color })}
            </button> :
            type === "transparent" ?
                <button
                disabled={disabled}
                    onClick={onClick}
                    className={`${className} text-sm h-12 py-2 hover:opacity-80 justify-center items-center gap-2 inline-flex `}
                >
                    {iconLeft && React.cloneElement(iconLeft, { fill: color })}
                    {initialValue &&
                        <span className={`font-medium line-clamp-1`}>
                            {initialValue}
                        </span>
                    }
                    {iconRight && React.cloneElement(iconRight, { fill: color })}
                </button> :
                null
    );
}

export default Button;
